import { create } from "zustand";

export interface AuthState {
  installId: string | null;
  sessionToken: string | null;
  setupToken: string | null;
  userId: string | null;
  tenantKey: string | null;
  appToken: string | null;
  displayName: string | null;
  enabledPlatforms: string[];
  hasPat: boolean;
  hasRobotWebhook: boolean;

  setSession: (s: {
    installId: string;
    sessionToken: string;
    displayName: string;
    enabledPlatforms: string[];
    hasPat: boolean;
    hasRobotWebhook: boolean;
  }) => void;
  setSetupToken: (token: string) => void;
  setBaseContext: (ctx: { appToken: string; userId: string; tenantKey: string | null }) => void;
  clearSession: () => void;
  reset: () => void;
}

const initialState = {
  installId: null,
  sessionToken: null,
  setupToken: null,
  userId: null,
  tenantKey: null,
  appToken: null,
  displayName: null,
  enabledPlatforms: [] as string[],
  hasPat: false,
  hasRobotWebhook: false,
};

export const useAuthStore = create<AuthState>((set) => ({
  ...initialState,
  setSession: (s) =>
    set({
      installId: s.installId,
      sessionToken: s.sessionToken,
      setupToken: null,
      displayName: s.displayName,
      enabledPlatforms: s.enabledPlatforms,
      hasPat: s.hasPat,
      hasRobotWebhook: s.hasRobotWebhook,
    }),
  setSetupToken: (token) => set({ setupToken: token, sessionToken: null, installId: null }),
  setBaseContext: ({ appToken, userId, tenantKey }) => set({ appToken, userId, tenantKey }),
  clearSession: () => set({ sessionToken: null, installId: null }),
  reset: () => set(initialState),
}));
